import React, { useState } from "react";
import "./PlayerNameForm.css";

const PlayerNameForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    player_name: "",
    company_name: "",
    player_email: "",
    player_phone: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.player_name.trim() && formData.company_name.trim()) {
      onSubmit(formData);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="player-name-form-container">
      <div className="form-card">
        <div className="logo-container">
          <img
            src="/peach-logo.png"
            alt="Peach"
            className="company-logo"
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        </div>

        <h1>🤖 Robot Jump Challenge</h1>
        <p className="subtitle">Enter your details to start playing!</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="player_name"
              placeholder="Your Name *"
              value={formData.player_name}
              onChange={handleChange}
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <input
              type="text"
              name="company_name"
              placeholder="Company Name *"
              value={formData.company_name}
              onChange={handleChange}
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <input
              type="email"
              name="player_email"
              placeholder="Email (optional)"
              value={formData.player_email}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="form-group">
            <input
              type="tel"
              name="player_phone"
              placeholder="Phone (optional)"
              value={formData.player_phone}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <button type="submit" className="start-button">
            Start Game
          </button>
        </form>

        <div className="instructions">
          <h3>How to Play</h3>
          <div className="instruction-grid">
            <div className="instruction-item">
              <div className="instruction-icon">🎮</div>
              <div className="instruction-text">
                <strong>Jump</strong>
                <span>Press SPACE or TAP to jump over obstacles</span>
              </div>
            </div>
            <div className="instruction-item">
              <div className="instruction-icon">⚡</div>
              <div className="instruction-text">
                <strong>AI Boost</strong>
                <span>Collect power-ups for extra speed</span>
              </div>
            </div>
            <div className="instruction-item">
              <div className="instruction-icon">🏆</div>
              <div className="instruction-text">
                <strong>Score Points</strong>
                <span>Avoid obstacles and survive longer</span>
              </div>
            </div>
            <div className="instruction-item">
              <div className="instruction-icon">🎁</div>
              <div className="instruction-text">
                <strong>Win Prizes</strong>
                <span>Score 250+ to spin the prize wheel!</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayerNameForm;
